import { mutatorAction } from 'satcheljs';
import CortanaComposeViewState from '../store/schema/CortanaComposeViewState';

export default mutatorAction('setFlexPaneResultsLoading', function setFlexPaneResultsLoading(
    viewState: CortanaComposeViewState,
    loading: boolean
) {
    viewState.flexPaneResultsLoading = loading;
});
